import React from "react";
import { Card, CardBody } from "reactstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const GradientWithRadialProgressCard = ({
  icon = "iconsminds-bell",
  title = "title",
  detail = "detail",
  percent = 80, // 0-100 value
  progressText = "8/10"
}) => {
  return (
    <Card className="progress-banner">
      <CardBody className="justify-content-between d-flex flex-row align-items-center">
        <div>
          <i
            className={`${icon} mr-2 text-white align-text-bottom d-inline-block`}
          />
          <div>
            <p className="lead text-white">{title}</p>
            <p className="text-small text-white">{detail}</p>
          </div>
        </div>
        <div className="progress-bar-circle progress-bar-banner position-relative">
          <CircularProgressbar
            value={percent}       // ✅ instead of percentage
            maxValue={100}        // optional, default is 100
            text={progressText}   // ✅ still works
            strokeWidth={4}
            styles={buildStyles({
              textColor: "#fff",
              pathColor: "#fff",
              trailColor: "rgba(255,255,255,0.2)"
            })}
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default GradientWithRadialProgressCard;
